module.exports = __webpack_public_path__ + "img/digital_tree.0a3f5da9.svg";